import Vue from "vue";
import mocksStore from "@/__mocks__/store-mock.js";
import SdkVeridas from "@/plugins/sdk-veridas";

describe("SdkVeridas", () => {
  let vm;

  beforeEach(() => {
    Vue.use(SdkVeridas);

    const mockStore = mocksStore;

    vm = new Vue({
      mixins: [SdkVeridas],
      store: mockStore
    });
  });

  afterEach(() => {
    jest.clearAllMocks();
  });

  it("debería mostrar Veridas SDK", () => {
    document.getElementsByTagName = jest.fn(() => [
      { classList: { add: jest.fn() } }
    ]);
    document.body.requestFullscreen = jest.fn();

    vm.showVeridasSdk();
    expect(vm.$store.dispatch).toHaveBeenCalledWith("DO_IS_VISIBLE_SDK", true);
  });

  it("debería ocultar Veridas SDK", async () => {
    document.exitFullscreen = jest.fn();
    document.getElementsByTagName = jest.fn(() => [
      { classList: { remove: jest.fn() } }
    ]);

    await vm.hideVeridasSdk();

    expect(vm.$store.dispatch).toHaveBeenCalledWith("DO_IS_VISIBLE_SDK", false);
    expect(vm.m_isIframeSdkVisible).toBe(false);
    expect(document.getElementsByTagName).toHaveBeenCalledWith("body");
  });

  it("debería precargar Veridas SDK", () => {
    jest.useFakeTimers();
    const mockIframeElement = document.createElement("iframe");
    mockIframeElement.id = "iframe-veridas";
    document.getElementById = jest.fn(() => mockIframeElement);

    vm.preloadSdk();

    expect(vm.$store.dispatch).toHaveBeenCalledWith("DO_PRELOAD_SDK", true);
    jest.advanceTimersByTime(500);
    expect(vm.$store.dispatch).toHaveBeenCalledWith(
      "DO_SAVE_IFRAME",
      mockIframeElement
    );
    jest.useRealTimers();
    expect(vm.m_preloadSdk).toBe(false);
  });

  it("debería destruir Veridas SDK", () => {
    document.getElementsByTagName = jest.fn(() => [
      { classList: { remove: jest.fn() } }
    ]);

    vm.destroySdk();

    expect(vm.$store.dispatch).toHaveBeenCalledWith("DO_SAVE_IFRAME", null);
    expect(vm.$store.dispatch).toHaveBeenCalledWith("DO_PRELOAD_SDK", false);
  });

  it("debería recargar el iframe de Veridas SDK", () => {
    vm.reloadSdk();
  });

  it("debería mostrar Veridas SDK para moz", () => {
    document.getElementsByTagName = jest.fn(() => [
      { classList: { add: jest.fn() } }
    ]);
    document.body.requestFullscreen = null;
    document.body.mozRequestFullScreen = jest.fn();

    vm.showVeridasSdk();

    expect(vm.$store.dispatch).toHaveBeenCalledWith("DO_IS_VISIBLE_SDK", true);
  });

  it("debería mostrar Veridas SDK para ms", () => {
    document.getElementsByTagName = jest.fn(() => [
      { classList: { add: jest.fn() } }
    ]);
    document.body.requestFullscreen = null;
    document.body.mozRequestFullScreen = null;
    document.body.msRequestFullscreen = jest.fn();

    vm.showVeridasSdk();

    expect(vm.$store.dispatch).toHaveBeenCalledWith("DO_IS_VISIBLE_SDK", true);
  });

  it("debería manejar errores al ocultar Veridas SDK", () => {
    document.getElementsByTagName = jest.fn(() => [
      { classList: { remove: jest.fn() } }
    ]);
    document.exitFullscreen = jest.fn(() => {
      throw new Error("Fake error");
    });

    expect(() => vm.hideVeridasSdk()).not.toThrow();
  });
});
